/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('../bootstrap')

import {
    SpinnerComponent,
    ButtonComponent,
    PurgeCssComponent,
    DialogBoxComponent,
} from '@GlobalComponents';

import routes from './routes'

import App from './App.vue'
import { createApp } from 'vue';
import { createPinia } from 'pinia'
import store from '../store'
import Vue3Sanitize from "vue-3-sanitize";

import GlobalHelperMixins from '../plugins/mixins/global_helper_mixins'

import { Chart, registerables } from 'chart.js';
import ChartjsPluginStacked100 from "chartjs-plugin-stacked100";

// const chart_watermark = {
//     id: "chart_watermark",
//     afterDraw: (chart) => {
//         const image = new Image();
//         image.src =
//             "/img/logo/ppd_analytics.svg";
//         if (image.complete) {
//             const image_height = 82; // Or you can use image.naturalHeight;
//             const image_width = 125; // Or you can use image.naturalWidth;
//             const ctx = chart.ctx;
//             const x = chart.chartArea.width - image_width;
//             const y = chart.chartArea.height - image_height;
//             ctx.globalAlpha = 0.35;
//             ctx.drawImage(image, x, y, image_width, image_height);
//             ctx.globalAlpha = 1;
//         } else {
//             image.onload = () => chart.draw();
//         }
//     },
// };
Chart.register(ChartjsPluginStacked100, ...registerables);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
const defaultOptions = {
    allowedTags: [ 'a', 'b', 'p', 'div', 'span', 'ul', 'ol', 'li', 'strong', '<br>', 'u' ],
    allowedAttributes: {
        'a': [ 'href' ]
    }
};
const app = createApp(App)
const pinia = createPinia()

app.mixin(GlobalHelperMixins)

// app.component('AppComponent', App)

// GLOBAL COMPONENTS REGISTATION
app.component('SpinnerComponent', SpinnerComponent)
app.component('ButtonComponent', ButtonComponent)
app.component('PurgeCssComponent', PurgeCssComponent)
app.component('DialogBoxComponent', DialogBoxComponent)
app.use(store)
    .use(pinia)
    .use(routes)
    .use(Vue3Sanitize, defaultOptions)
    .mount('#app')
